// Slider Logic ----------------------------------------------------

let slideIndex = 1;
showSlides(slideIndex);

function plusSlides(n) {
  showSlides((slideIndex += n));
}

function currentSlide(n) {
  showSlides((slideIndex = n));
}

function showSlides(n) {
  let i;
  let slides = document.getElementsByClassName("mySlides");
  if (n > slides.length) {
    slideIndex = 1;
  }
  if (n < 1) {
    slideIndex = slides.length;
  }
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  slides[slideIndex - 1].style.display = "flex";
}

// -----------------------------------------------------------------

// Cart Logic ------------------------------------------------------

function addToCart(event, productId) {
  if (event) event.preventDefault();

  //Check Data
  const variant1Dropdown = document.getElementById(`Option-${productId}-0`);
  const variant2Dropdown = document.getElementById(`Option-${productId}-1`);

  if (variant1Dropdown && variant2Dropdown) {
    const selected = variant1Dropdown.options[variant1Dropdown.selectedIndex];
    const dataId = selected.getAttribute("data-id");

    const selected2 = variant2Dropdown.options[variant2Dropdown.selectedIndex];
    const dataId2 = selected2.getAttribute("data-id");

    if (dataId === "default") {
      variant1Dropdown.setCustomValidity("Please select your bag size!");
      variant1Dropdown.reportValidity();
      return;
    } else {
      variant1Dropdown.setCustomValidity("");
    }

    if (dataId2 === "default") {
      variant2Dropdown.setCustomValidity("Please select your grind size!");
      variant2Dropdown.reportValidity();
      return;
    } else {
      variant2Dropdown.setCustomValidity("");
    }
  }

  // Gather form data
  const form = document.getElementById(`product-form-${productId}`);
  const formData = new FormData(form);

  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error("Network response was not ok.");
      }
    })
    .then((data) => {
      updateCart();
    })
    .catch((error) => console.error("Error:", error));
}

function updateCart() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      const cart = document.querySelector(".cont-detalle-cart");
      const cartCount = document.querySelector(".cart-count-bubble>span");
      const totalPrice = document.querySelector(".ppprice");
      const itemList = document.getElementById("listItemsCart");

      if (cartCount) cartCount.textContent = data.item_count;
      if (cart) cart.classList.add("open");
      if (totalPrice) totalPrice.textContent = formatMoney(data.total_price);

      updateFreeShippingMessage(
        data.items_subtotal_price / 100, // Check function on cart-drawer-2
        data.items_subtotal_price,
        data.item_count
      );

      if (itemList) {
        itemList.innerHTML = "";

        for (let item of data.items) {
          const itemHtml = `
          <li>
            <div class="cleft-block">
              <div class="cart-P-img">
                <img src="${item.image}" alt="${item.featured_image.alt}">
              </div>
              <div class="context">
                <h4>${item.title}</h4>
                <span class="product-selling-name">${
                  item.selling_plan_allocation?.selling_plan.name || ""
                }</span>
                <div class="continputcart" id="itemcart${item.id}">
                  <div class="icos">
                    <span rel="-1" class="change-q">-</span>
                  </div>
                  <input type="text" value="${item.quantity}" data-id="${
            item.id
          }" disabled>
                  <div class="icos">
                    <span rel="1" class="change-q">+</span>
                  </div>
                </div>
                <div class="price">
                  ${formatMoney(item.price)}
                </div>
              </div>
            </div>
            <div class="del-icon">
              <button aria-label="Delete item" class="delete-btn cart-remove-button" onclick="deletepro(${
                item.id
              })" data-id="${item.id}">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </div>
          </li>`;
          itemList.insertAdjacentHTML("beforeend", itemHtml);
        }
      }
    })
    .catch((error) => console.error("Error trying to update cart:", error));
}

// -----------------------------------------------------------------

// Variant Logic ---------------------------------------------------
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (this.currentVariant && !this.currentVariant.available) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable(true);
    } else {
      this.updateVariantInput();
      this.toggleAddButton(false, "", false);
      this.setUnavailable(false);
    }
  }

  updateSellingPlan() {
    const productID = this.dataset.section;

    const sellingIdLabel = document.getElementById(`selling-id-${productID}`);
    let selling_plan_id;

    if (sellingIdLabel && sellingIdLabel.textContent !== "selling_plan_id")
      selling_plan_id = sellingIdLabel.textContent;

    const productData = JSON.parse(
      document.getElementById(`product-data-${productID}`).textContent
    );

    changePriceSubscription(selling_plan_id, productID, productData);
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    const sizeSelector = document.getElementById(
      `Option-${this.dataset.section}-0`
    );
    let sizeSelected = "12oz";

    if (sizeSelector) sizeSelected = sizeSelector.value;

    if (!this.currentVariant) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.options.includes(sizeSelected);
      });
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];

      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      if (optionInputs.length > availableOptionInputsValue.length) {
        availableOptionInputsValue.unshift("Select");
      }
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        let textreplace = window.variantStrings.unavailable_with_option.replace(
          "- Unavailable",
          ""
        );
        input.innerText = textreplace.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable(disable) {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );

    if (disable) {
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add("visibility-hidden");
      if (pricePerItem) pricePerItem.classList.add("visibility-hidden");
    } else {
      if (!addButton) return;
      addButtonText.textContent = "Add to cart";
      if (price) {
        const selectedVariant = this.getVariantData().find(
          (variant) => variant.id === this.currentVariant.id
        );

        price.classList.remove("visibility-hidden");

        if (selectedVariant) {
          const pricesText = document.querySelectorAll(
            ".price__regular .price-item"
          );

          if (pricesText)
            pricesText.forEach((p) => {
              p.textContent = this.formatMoney(selectedVariant.price);
            });

          const priceTextRegular = document.getElementById(
            `price-regular-base-${this.dataset.section}`
          );

          if (priceTextRegular)
            priceTextRegular.textContent = formatMoney(selectedVariant.price);

          this.updateSellingPlan();
        }
      }
      if (pricePerItem) pricePerItem.classList.remove("visibility-hidden");
    }
  }

  formatMoney(amount) {
    const currency = window.shopCurrency || "USD";
    const price = amount / 100;
    const formattedPrice =
      price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
    return `$${formattedPrice} ${currency}`;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// -----------------------------------------------------------------

// Selling Plan Logic ----------------------------------------------

document.addEventListener("DOMContentLoaded", (event) => {
  const sellingRadios = document.getElementsByName("selling_plan");

  sellingRadios.forEach((plan) => {
    plan.addEventListener("change", (event) => {
      const selling_plan_id = event.target.value;
      const productID = plan.dataset.product;

      const sellingIdLabel = document.getElementById(`selling-id-${productID}`);
      sellingIdLabel.textContent = selling_plan_id;

      const productData = JSON.parse(
        document.getElementById(`product-data-${productID}`).textContent
      );

      changePriceSubscription(selling_plan_id, productID, productData);
    });
  });
});

function changePriceSubscription(selling_plan_id, productID, productData) {
  if (!selling_plan_id) {
    //One time Purchase
    const sellingBadge = document.getElementById(
      `badge_subscription-${productID}`
    );
    if (sellingBadge) sellingBadge.classList.remove("display_badge");

    const sellingCompare = document.getElementById(`price-sale-${productID}`);
    if (sellingCompare) sellingCompare.classList.remove("display_badge");

    const sellingRegular = document.getElementById(
      `price-regular-${productID}`
    );
    if (sellingRegular) sellingRegular.classList.remove("remove_regular");
  } else {
    let selling_plan;

    for (let group of productData.selling_plan_groups) {
      for (let g_plan of group.selling_plans) {
        if (`${g_plan.id}` === selling_plan_id) {
          selling_plan = g_plan;
          break;
        }
      }
    }

    if (!selling_plan) return;

    const sellingBadge = document.getElementById(
      `badge_subscription-${productID}`
    );
    if (sellingBadge) sellingBadge.classList.add("display_badge");

    const sellingCompare = document.getElementById(`price-sale-${productID}`);
    if (sellingCompare) sellingCompare.classList.add("display_badge");

    const sellingRegular = document.getElementById(
      `price-regular-${productID}`
    );
    if (sellingRegular) sellingRegular.classList.add("remove_regular");

    // Change Price Data
    const selectedVariantItem = document.getElementById(
      `product-variant-id-${productID}`
    );
    let selectedVariantID;
    selectedVariantID = selectedVariantItem.value;

    let selectedVariant;
    if (selectedVariantID)
      selectedVariant = productData.variants.find(
        (variant) => `${variant.id}` === selectedVariantID
      );

    if (selectedVariant) {
      const regularPrice = selectedVariant.price;
      let adjustedPrice = regularPrice;

      if (
        selling_plan.price_adjustments &&
        selling_plan.price_adjustments.length > 0
      ) {
        const adjustment = selling_plan.price_adjustments[0];

        if (adjustment.value_type === "percentage") {
          adjustedPrice = (regularPrice * (100 - adjustment.value)) / 100;
        } else if (adjustment.value_type === "fixed_amount") {
          adjustedPrice = regularPrice - adjustment.value;
        } else if (adjustment.value_type === "price") {
          adjustedPrice = adjustment.value;
        }
      }

      const pricesText = document.querySelectorAll(
        `.price__sale .price-item:not(#price-regular-base-${productID})`
      );

      if (pricesText)
        pricesText.forEach((p) => {
          p.textContent = formatMoney(adjustedPrice);
        });

      const priceTextRegular = document.getElementById(
        `price-regular-base-${productID}`
      );

      if (priceTextRegular)
        priceTextRegular.textContent = formatMoney(regularPrice);
    }
  }
}

function formatMoney(amount) {
  const currency = window.shopCurrency || "USD";
  const price = amount / 100;
  const formattedPrice = price % 1 === 0 ? price.toFixed(0) : price.toFixed(2);
  return `$${formattedPrice} ${currency}`;
}

// -----------------------------------------------------------------

// -----------------------------------------------------------------

// -----------------------------------------------------------------

// -----------------------------------------------------------------

// -----------------------------------------------------------------

// -----------------------------------------------------------------
